import { useState } from 'react';
import PropTypes, { string } from 'prop-types';
import { Dropzone, FileItem, FullScreenPreview } from '@dropzone-ui/react';

export default function DropzoneFile({ files, onChangeFiles, maxFile = 7 }) {
  const [imageSrc, setImageSrc] = useState(undefined);

  const onDelete = (id) => {
    onChangeFiles(files.filter((x) => x.id !== id));
  };

  const handleSee = (imageSource) => {
    setImageSrc(imageSource);
  };

  const handleClean = (dataFiles) => {
    console.log('list cleaned', dataFiles);
  };

  return (
    <Dropzone
      label="Drop your images here..."
      style={{ width: '100%', borderRadius: 40, padding: 30 }}
      view="list"
      onChange={onChangeFiles}
      minHeight="195px"
      onClean={handleClean}
      value={files}
      maxFiles={maxFile}
      header={false}
      footer={false}
      accept=".png, image/*"
      disableScroll>
      {files.map((file) => (
        <FileItem
          {...file}
          key={file.id}
          onDelete={onDelete}
          onSee={handleSee}
          resultOnTooltip
          preview
          info
          hd
        />
      ))}
      <FullScreenPreview
        imgSource={imageSrc}
        openImage={imageSrc}
        onClose={(e) => handleSee(undefined)}
      />
    </Dropzone>
  );
}

DropzoneFile.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  files: PropTypes.any.isRequired,
  onChangeFiles: PropTypes.func.isRequired,
  maxFile: PropTypes.number,
};
DropzoneFile.defaultProps = {
  maxFile: 7,
};
